import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "controlsBox" }
const _hoisted_2 = { class: "controlTitle" }
const _hoisted_3 = { class: "controlPrompt" }
const _hoisted_4 = { class: "controlPromptOne" }
const _hoisted_5 = { class: "controlPromptMain" }
const _hoisted_6 = { class: "controlPromptOne" }
const _hoisted_7 = { class: "controlPromptMain" }
const _hoisted_8 = { class: "controlPromptOne" }
const _hoisted_9 = { class: "controlPromptMain" }
const _hoisted_10 = { class: "controlPromptOne" }
const _hoisted_11 = { class: "controlPromptMain" }
const _hoisted_12 = { class: "controlBtn" }
const _hoisted_13 = { class: "leftBtn" }
const _hoisted_14 = { class: "btnBox" }

import {
    Close,
} from "@element-plus/icons-vue";
import { ref, onMounted,watch} from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'control',
  props: {
    initRule:Object,
    textfilterShow:Boolean,
    textinspectShow:Boolean
},
  emits: ['closeThis','changeRule','openRule','openFilterTxt'],
  setup(__props, { emit: __emit }) {

const props = __props
const rule=ref({
    maximumDuration: '10',
    minimumDuration: '1',
    originalMaximumWordCount: '18',
    translationOriginalMaximumWordCount: '75'
})
const openCheck=ref(false)//是否开启检查
const filterRule=ref(false)//是否过滤不符规则的字幕
const checkStyle={
    background:'rgba(32,124,246,0.9)',
}
// initRule
const emit = __emit
// 关闭弹窗
const closeBox=()=>{
    openCheck.value=false
    emit('openRule',openCheck.value)
    filterRule.value=false
    emit('openFilterTxt',filterRule.value)
    emit('closeThis')
}
// // 检测规则变化
// watch(() =>rule.value,(newVal)=>{
//     console.log(newVal)

    
// }, { deep: true })

onMounted(()=>{
    console.log(props.initRule)
    rule.value=JSON.parse(JSON.stringify(props.initRule))
    openCheck.value=props.textinspectShow
    if(props.textinspectShow){
        filterRule.value=props.textfilterShow
    }else{
        filterRule.value=false
    }
})
const handleClose = () => {
    openCheck.value=true
    emit('openRule',openCheck.value)
    // console.log(tolanguage.value)
    // emit('changeRule',JSON.stringify(rule.value))
}
// 关闭检查
const checkClose = () => {
    openCheck.value=false
    filterRule.value=false
    emit('openRule',openCheck.value)
}
// 更新规则
const updataRule=()=>{
    emit('changeRule',JSON.stringify(rule.value))
}
// 检测是否筛选不符合字幕
const filterChange=()=>{
    filterRule.value=!filterRule.value
   emit('openFilterTxt',filterRule.value)
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("span", null, "设置检查规则", -1)),
      _createElementVNode("span", {
        class: "closeBtn",
        onClick: closeBox
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(Close))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "controlPromptTitle" }, "每条字幕最长持续时间 (5-60秒)", -1)),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "请输入",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rule.value.maximumDuration) = $event)),
            onBlur: updataRule
          }, null, 544), [
            [_vModelText, rule.value.maximumDuration]
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("span", null, "秒", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "controlPromptTitle" }, "每条字幕最短持续时间 (0.1-4秒)", -1)),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "请输入",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((rule.value.minimumDuration) = $event)),
            onBlur: updataRule
          }, null, 544), [
            [_vModelText, rule.value.minimumDuration]
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("span", null, "秒", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "controlPromptTitle" }, "每行字幕最多字数 (10-100个)", -1)),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "请输入",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rule.value.originalMaximumWordCount) = $event)),
            onBlur: updataRule
          }, null, 544), [
            [_vModelText, rule.value.originalMaximumWordCount]
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("span", null, "个", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "controlPromptTitle" }, "译文每行字幕最多字数 (10-100个)", -1)),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "请输入",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((rule.value.translationOriginalMaximumWordCount) = $event)),
            onBlur: updataRule
          }, null, 544), [
            [_vModelText, rule.value.translationOriginalMaximumWordCount]
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("span", null, "个", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        (openCheck.value)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onClick: _withModifiers(filterChange, ["stop"]),
              style: _normalizeStyle(filterRule.value?checkStyle:'')
            }, "只显示不符字幕", 4))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("span", {
          class: "btnNo",
          onClick: _withModifiers(closeBox, ["stop"])
        }, "取消"),
        (!openCheck.value)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "btnOk",
              onClick: _withModifiers(handleClose, ["stop"])
            }, "开始检查"))
          : _createCommentVNode("", true),
        (openCheck.value)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "btnOk",
              onClick: _withModifiers(checkClose, ["stop"])
            }, "关闭检查"))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})